import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import { Plus } from './icons';
import { colors, formes, spacing } from '../theme/tokens';
import { t } from '../i18n';
import { interfaceRtl } from '../i18n/sens';

export interface EnteteSectionProps {
  titre: string;
  onAjouter: () => void;
  // Phrase complète pour le lecteur d'écran (« Ajouter une expérience ») : le lien visible dit
  // seulement « Ajouter », ce qu'il ajoute se déduit du titre au-dessus, pas d'un lecteur d'écran.
  ajouterA11y: string;
  ajouterTestID?: string;
}

/**
 * En-tête d'une section de saisie du CV : titre en petites capitales grises à gauche, lien
 * « + Ajouter » bleu à l'autre bout. Le lien est au-dessus de la liste, donc atteignable sans la
 * faire défiler, et il garde une cible de 44 pt.
 */
export function EnteteSection({ titre, onAjouter, ajouterA11y, ajouterTestID }: EnteteSectionProps) {
  return (
    <View style={styles.entete}>
      <Text accessibilityRole="header" style={[styles.titre, interfaceRtl() && styles.titreSansEspacement]}>
        {titre}
      </Text>
      <Pressable
        testID={ajouterTestID}
        accessibilityRole="button"
        accessibilityLabel={ajouterA11y}
        onPress={onAjouter}
        style={styles.ajouter}
      >
        <Plus size={15} color={colors.electricDeep} strokeWidth={3} />
        <Text style={styles.ajouterTexte}>{t('misc.add')}</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  entete: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', minHeight: formes.cible },
  titre: {
    flexShrink: 1,
    fontSize: 12,
    fontWeight: '800',
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    color: colors.grey500,
  },
  // Un espacement non nul sépare les lettres arabes, qui doivent rester liées.
  titreSansEspacement: { letterSpacing: 0 },
  ajouter: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    minHeight: formes.cible,
    paddingStart: spacing.md,
  },
  ajouterTexte: { fontSize: 14, fontWeight: '800', color: colors.electricDeep },
});
